<div class="main-container">
    <mat-card class="cardWithShadow">
        <mat-card-header>
            <div style="display: flex; justify-content: space-between; width: 100%;">
                <div>
                    <mat-card-title *ngIf="dataSource.data"> Products ({{ dataSource.data.length || 0
                        }})</mat-card-title>
                    <span class="subtitle">Your stripe products.</span>
                </div>

                <div style="display: flex; gap: 15px; align-items: center;">
                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                        <input matInput (keyup)="applyFilter($event)" placeholder="{{ 'SearchHere' | translate }}"
                            #input />
                    </mat-form-field>
                    <button class="m-l-15" mat-mini-fab color="primary" matTooltip="{{ 'Add' | translate}}"
                        (click)="showCreateProductModal()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>

        </mat-card-header>
        <mat-card-content class="p-24">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" class="w-100">

                    <ng-container matColumnDef="product">
                        <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">Product</th>
                        <td mat-cell *matCellDef="let element">
                            <div class="d-flex align-items-center">
                                <img *ngIf="element.images?.[0]" [src]="element.images[0]" alt="{{ element.name }}"
                                    class="product-image" />
                                <p class="f-w-600 mat-subtitle f-s-16 product-name">
                                    {{ element.name }}
                                </p>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                            Description
                        </th>
                        <td mat-cell *matCellDef="let element" class="f-s-14">{{ element.description }}</td>
                    </ng-container>

                    <ng-container matColumnDef="price">
                        <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                            Price
                        </th>
                        <td mat-cell *matCellDef="let element" class="f-s-14">
                            <ng-container *ngIf="element.prices?.[0]?.unit_amount as price">
                                <span class="price-badge bg-primary">{{ price / 100 }} {{ element.prices?.[0]?.currency
                                    }}</span>
                            </ng-container>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="createdAt">
                        <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                            Created At
                        </th>
                        <td mat-cell *matCellDef="let element" class="f-s-14">
                            <span>{{ element.created * 1000 | date:'dd/MM/yyyy' }}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="updatedAt">
                        <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                            Updated At
                        </th>
                        <td mat-cell *matCellDef="let element" class="f-s-14">
                            <span>{{ element.updated * 1000 | date:'dd/MM/yyyy' }}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                            Actions
                        </th>
                        <td mat-cell *matCellDef="let element" class="action-link">
                            <div style="display: flex;">
                                <a class="m-r-10 cursor-pointer icon" matTooltip="Edit"
                                    (click)="editProduct(element.id)"><i-tabler name="edit"
                                        class="icon-18"></i-tabler></a>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
                <div class="loading" *ngIf="loading">
                    <ngx-skeleton-loader [count]="10" [theme]="{ 'border-radius': '0', height: '50px' }"
                        [appearance]="'line'">
                    </ngx-skeleton-loader>
                </div>
                <mat-paginator [pageSizeOptions]="[25,50]" [length]="dataSource?.data?.length" [pageSize]="pageSize"
                    showFirstLastButtons></mat-paginator>
            </div>
        </mat-card-content>
    </mat-card>
</div>

<p-dialog header="Create Product" [(visible)]="createProductModalVisible" [modal]="true" [draggable]="false"
    [resizable]="false" [style]="{width: '450px'}">
    <div class="product-form">
        <div class="card-title-container">
            <img src="assets/images/stripe-logo-96x96.png" alt="stripe-logo" class="dialog-logo" />
            <p class="subtitle">
                Create a new product in Stripe.
            </p>
            <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
        </div>

        <div class="form-container">
            <form [formGroup]="createProductForm" (ngSubmit)="createProduct()">
                <!-- Product Name -->
                <div class="form-group">
                    <label class="form-label">Name <sup class="required">*</sup></label>
                    <input pInputText formControlName="name" placeholder="Enter product name" />
                    <div class="required-error"
                        *ngIf="createProductForm.controls['name'].invalid && createProductForm.controls['name'].touched">
                        Product name is required.
                    </div>
                </div>

                <!-- Description -->
                <div class="form-group">
                    <label class="form-label">Description</label>
                    <textarea pInputTextarea formControlName="description"
                        placeholder="Enter product description"></textarea>
                </div>

                <!-- Currency -->
                <div class="form-group">
                    <label class="form-label">Currency <sup class="required">*</sup></label>
                    <p-dropdown [options]="currencies" formControlName="currency" optionLabel="label"
                        optionValue="value" placeholder="Select currency">
                    </p-dropdown>
                    <div class="required-error"
                        *ngIf="createProductForm.controls['currency'].invalid && createProductForm.controls['currency'].touched">
                        Please select a currency.
                    </div>
                </div>

                <!-- Price -->
                <div class="form-group">
                    <label class="form-label">Price<sup class="required">*</sup></label>
                    <input pInputText type="number" formControlName="price" placeholder="0" />
                    <div class="required-error"
                        *ngIf="createProductForm.controls['price'].invalid && createProductForm.controls['price'].touched">
                        Price is required.
                    </div>
                </div>

                <!-- Image Upload -->
                <div class="form-group">
                    <label class="form-label">Product Image</label>

                    <!-- input file oculto -->
                    <input type="file" #fileInput (change)="onFileSelected($event)" accept="image/*" hidden />

                    <!-- botón estilizado -->
                    <button mat-raised-button color="primary" type="button" (click)="fileInput.click()" #fileInput>
                        Select image
                    </button>

                    <!-- nombre del archivo -->
                    <span class="file-name" *ngIf="selectedFileName">{{ selectedFileName }}</span>
                </div>

                <!-- Submit -->
                <div class="text-center m-t-3">
                    <button mat-raised-button color="primary" type="submit"
                        [disabled]="createProductForm.invalid || !selectedFile || loading">
                        Create product
                    </button>
                </div>
            </form>
        </div>
    </div>
</p-dialog>

<p-dialog header="Update Product" [(visible)]="updateProductModalVisible" [modal]="true" [draggable]="false"
    [resizable]="false" [style]="{width: '450px'}">
    <div class="product-form">
        <div class="card-title-container">
            <img src="assets/images/stripe-logo-96x96.png" alt="stripe-logo" class="dialog-logo" />
            <p class="subtitle">
                Update your product in Stripe.
            </p>
            <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
        </div>

        <div class="form-container">
            <form [formGroup]="updateProductForm" (ngSubmit)="updateProduct()">
                <!-- Product Name -->
                <div class="form-group">
                    <label class="form-label">Name <sup class="required">*</sup></label>
                    <input pInputText formControlName="name" placeholder="Enter product name" />
                    <div class="required-error"
                        *ngIf="updateProductForm.controls['name'].invalid && updateProductForm.controls['name'].touched">
                        Product name is required.
                    </div>
                </div>

                <!-- Description -->
                <div class="form-group">
                    <label class="form-label">Description</label>
                    <textarea pInputTextarea formControlName="description"
                        placeholder="Enter product description"></textarea>
                </div>

                <!-- Currency -->
                <div class="form-group">
                    <label class="form-label">Currency <sup class="required">*</sup></label>
                    <p-dropdown [options]="currencies" formControlName="currency" optionLabel="label"
                        optionValue="value" placeholder="Select currency">
                    </p-dropdown>
                    <div class="required-error"
                        *ngIf="updateProductForm.controls['currency'].invalid && updateProductForm.controls['currency'].touched">
                        Please select a currency.
                    </div>
                </div>

                <!-- Price -->
                <div class="form-group">
                    <label class="form-label">Price<sup class="required">*</sup></label>
                    <input pInputText type="number" formControlName="price" placeholder="0" />
                    <div class="required-error"
                        *ngIf="updateProductForm.controls['price'].invalid && updateProductForm.controls['price'].touched">
                        Price is required.
                    </div>
                </div>

                <!-- Image Upload -->
                <div class="form-group">
                    <label class="form-label">Product Image</label>

                    <!-- input file oculto -->
                    <input type="file" #fileInput (change)="onFileSelected($event)" accept="image/*" hidden />

                    <!-- botón estilizado -->
                    <button mat-raised-button color="primary" type="button" (click)="fileInput.click()" #fileInput>
                        Select image
                    </button>

                    <!-- nombre del archivo -->
                    <span class="file-name" *ngIf="selectedFileName">{{ selectedFileName }}</span>
                </div>

                <!-- Submit -->
                <div class="text-center m-t-3">
                    <button mat-raised-button color="primary" type="submit"
                        [disabled]="updateProductForm.invalid || loading">
                        Update product
                    </button>
                </div>
            </form>
        </div>
    </div>
</p-dialog>